module.exports = require('./lib/react.js')



//////////////////
// WEBPACK FOOTER
// ./~/glamor/react.js
// module id = 7
// module chunks = 168707334958949